<template>
  <b-row class="text-center">
    <b-col>
      <h4>
        Your email address is confirmed!
        <br>
        You can now log in by clicking below.
      </h4>
      <router-link
        tag="span"
        class="btn btn-primary"
        :to="{ name: 'Login' }"
      >
        LOGIN
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
// external dependencies

// custom component

// api call
import UserAPI from '@/api/UserAPI'

export default {
  name: 'ConfirmCustomer',
  props: ['ck', 'u'],
  mounted: function () {
    this.confirmEmail()
  },
  data () {
    return {
      confirm_data: {
        ck: this.ck,
        u: this.u
      }
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    confirmEmail: async function () {
      await UserAPI.confirmEmail(this.confirm_data)
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ConfirmCustomer/ConfirmCustomer.vue